"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyCode = void 0;
exports.KeyCode = {
    ENTER: 13,
    ESCAPE: 27,
    bind(keyEvents) {
        return (e) => {
            const event = keyEvents[e.keyCode];
            if (event == null) {
                return;
            }
            event(e);
        };
    }
};
//# sourceMappingURL=key.binding.js.map